/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskPolicyBypassRequestsApprove } from "../funcs/riskPolicyBypassRequestsApprove.js";
import { riskPolicyBypassRequestsCreate } from "../funcs/riskPolicyBypassRequestsCreate.js";
import { riskPolicyBypassRequestsDeny } from "../funcs/riskPolicyBypassRequestsDeny.js";
import { riskPolicyBypassRequestsList } from "../funcs/riskPolicyBypassRequestsList.js";
import { riskPolicyBypassRequestsRevoke } from "../funcs/riskPolicyBypassRequestsRevoke.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListRiskPolicyBypassRequestsResult } from "../models/components/listriskpolicybypassrequestsresult.js";
import { PolicyBypassRedemption } from "../models/components/policybypassredemption.js";
import { RiskPolicyBypassRequest } from "../models/components/riskpolicybypassrequest.js";
import {
  ApproveRiskPolicyBypassRequestRequest,
  ApproveRiskPolicyBypassRequestSecurity,
} from "../models/operations/approveriskpolicybypassrequest.js";
import {
  CreateRiskPolicyBypassRequestRequest,
  CreateRiskPolicyBypassRequestSecurity,
} from "../models/operations/createriskpolicybypassrequest.js";
import {
  DenyRiskPolicyBypassRequestRequest,
  DenyRiskPolicyBypassRequestSecurity,
} from "../models/operations/denyriskpolicybypassrequest.js";
import {
  ListRiskPolicyBypassRequestsRequest,
  ListRiskPolicyBypassRequestsSecurity,
} from "../models/operations/listriskpolicybypassrequests.js";
import {
  RevokeRiskPolicyBypassRequestRequest,
  RevokeRiskPolicyBypassRequestSecurity,
} from "../models/operations/revokeriskpolicybypassrequest.js";
import { unwrapAsync } from "../types/fp.js";

export class PolicyBypassRequests extends ClientSDK {
  /**
   * approveRiskPolicyBypassRequest risk
   *
   * @remarks
   * Approve a risk policy bypass request for the requested policy target.
   */
  async approve(
    request: ApproveRiskPolicyBypassRequestRequest,
    security?: ApproveRiskPolicyBypassRequestSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicyBypassRequest> {
    return unwrapAsync(riskPolicyBypassRequestsApprove(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createRiskPolicyBypassRequest risk
   *
   * @remarks
   * Create or refresh a risk policy bypass request from a signed request URL token.
   */
  async create(
    request: CreateRiskPolicyBypassRequestRequest,
    security?: CreateRiskPolicyBypassRequestSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PolicyBypassRedemption> {
    return unwrapAsync(riskPolicyBypassRequestsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * denyRiskPolicyBypassRequest risk
   *
   * @remarks
   * Deny a risk policy bypass request, updating workflow state.
   */
  async deny(
    request: DenyRiskPolicyBypassRequestRequest,
    security?: DenyRiskPolicyBypassRequestSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicyBypassRequest> {
    return unwrapAsync(riskPolicyBypassRequestsDeny(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRiskPolicyBypassRequests risk
   *
   * @remarks
   * List current risk policy bypass request workflow records.
   */
  async list(
    request?: ListRiskPolicyBypassRequestsRequest | undefined,
    security?: ListRiskPolicyBypassRequestsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRiskPolicyBypassRequestsResult> {
    return unwrapAsync(riskPolicyBypassRequestsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeRiskPolicyBypassRequest risk
   *
   * @remarks
   * Revoke a previously approved risk policy bypass request.
   */
  async revoke(
    request: RevokeRiskPolicyBypassRequestRequest,
    security?: RevokeRiskPolicyBypassRequestSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicyBypassRequest> {
    return unwrapAsync(riskPolicyBypassRequestsRevoke(
      this,
      request,
      security,
      options,
    ));
  }
}
